import { Address } from '../../../lib/models/api/address.model';
import { Deserializable } from '../../../lib/models/deserializable';

export class ApplicantResidence implements Deserializable {
  public ResidenceID: number;
  public ApplicantNumber?: number;
  public AddressID?: number;
  public ApplicantResidenceOrder?: number;
  public CurrentResidence?: boolean;
  public MonthsAtAddress?: number;
  public ResidenceTypeCode: string;
  public YearsAtAddress?: number;
  public ResidenceTypeDetails: string;
  public ShareYourAccommodationCode: string;
  public Address: Address;

  constructor() {
    this.Address = new Address();
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    this.Address = new Address().deserialize(input.Address);

    return this;
  }
}
